import React, { useState } from 'react';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';

const FloatingManualButton = ({ url = "/manuals/Teacher_User_Manual.pdf", label = "User Manual" }) => {
    const [showToast, setShowToast] = useState(false);

    const handleClick = (e) => {
        if (!url || url === '#') {
            e.preventDefault();
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
        }
    };

    return (
        <>
            <a
                href={url || '#'}
                target={url && url !== '#' ? "_blank" : "_self"}
                rel="noopener noreferrer"
                onClick={handleClick}
                className="fixed bottom-6 right-6 z-50 hidden md:flex items-center gap-2 bg-[#18216D] text-white px-5 py-3.5 rounded-full shadow-2xl hover:bg-indigo-800 transition-all hover:-translate-y-1 hover:shadow-indigo-900/30 group"
            >
                <DocumentArrowDownIcon className="w-5 h-5 text-[#FFC425] group-hover:scale-110 transition-transform" />
                <span className="text-xs font-black uppercase tracking-widest">{label}</span>
            </a>

            {/* Coming Soon Toast */}
            <div className={`fixed bottom-24 right-6 bg-slate-800 text-white px-4 py-3 rounded-xl shadow-lg transition-all duration-300 z-50 flex items-center gap-3 ${showToast ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
                <i className="fas fa-info-circle text-[#FFC425]"></i>
                <span className="text-xs font-bold">The user manual is coming soon!</span>
            </div>
        </>
    );
};

export default FloatingManualButton;
